import { render, staticRenderFns } from "./CreateSparepartRequest.vue?vue&type=template&id=126643ae&"
import script from "./CreateSparepartRequest.vue?vue&type=script&lang=ts&"
export * from "./CreateSparepartRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('126643ae')) {
      api.createRecord('126643ae', component.options)
    } else {
      api.reload('126643ae', component.options)
    }
    module.hot.accept("./CreateSparepartRequest.vue?vue&type=template&id=126643ae&", function () {
      api.rerender('126643ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistic/sparepart-request/CreateSparepartRequest.vue"
export default component.exports